/* ==========================================================================
   BM custom: engraving add-ons (loaded after bm-engraving.js)
   1. Font picker      - required when present. Saved as:
                           properties[Engraving font]        customer name (e.g. "Quicksand")
                           properties[_Engraving font file]  production name (e.g. "Quicksand Bold"),
                                                             hidden from customers (underscore)
                         Shows the chosen name after the label ("FONT*: Allura").
                         The engraving preview renders in the chosen font (+ size scale).
   2. English only     - strips any character outside A-Z a-z 0-9 space - . ,
                         from every engraving text field (same set as the input pattern).
   3. Ring style carry - when the customer switches "Ring style" (a different product),
                         keep their text, font and symbol on the next page.
   Namespaced in an IIFE; no globals.
   ========================================================================== */
(function () {
  'use strict';

  var CARRY_KEY = 'bmEngravingCarry';
  var CARRY_MAX_AGE_MS = 10 * 60 * 1000; // ignore carried values older than 10 min
  var DISALLOWED_CHARS = /[^A-Za-z0-9\s\-\.\,]/g;

  function storageGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function storageSet(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (e) { /* private mode etc. */ }
  }
  function storageRemove(key) {
    try { window.sessionStorage.removeItem(key); } catch (e) { /* noop */ }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.bm-engraving');
    if (!root) return;

    var form = document.querySelector('form.product-single__form[action*="/cart/add"]');
    var textInputs = root.querySelectorAll('.bm-engraving__text-input');
    var picker = root.querySelector('[data-bm-font-picker]');
    var fontInputs = picker ? picker.querySelectorAll('.bm-engraving-font__input') : [];
    var labelValue = picker ? picker.querySelector('[data-font-label-value]') : null;
    var preview = root.querySelector('[data-single-preview]');

    /* -- 2. English-only filter ------------------------------------------ */
    Array.prototype.forEach.call(textInputs, function (input) {
      input.addEventListener('input', function () {
        var cleaned = input.value.replace(DISALLOWED_CHARS, '');
        if (cleaned === input.value) return;

        var caret = input.selectionStart - (input.value.length - cleaned.length);
        input.value = cleaned;
        try { input.setSelectionRange(caret, caret); } catch (e) { /* noop */ }
        // Let bm-engraving.js re-render its preview with the cleaned value
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });

    /* -- 1. Font picker --------------------------------------------------- */
    function getSelectedFont() {
      for (var i = 0; i < fontInputs.length; i++) {
        if (fontInputs[i].checked) return fontInputs[i];
      }
      return null;
    }

    function applyFont(input) {
      if (!input) return;
      // "FONT*: Allura" - customer name only (never the production name)
      if (labelValue) labelValue.textContent = input.value;
      if (!preview) return;
      // Scoped to the preview so the text box itself stays in the site font (readable while typing)
      preview.style.setProperty('--bm-engraving-font', input.getAttribute('data-font-family'));
      preview.style.setProperty('--bm-engraving-font-weight', input.getAttribute('data-font-weight') || 'inherit');
      preview.style.setProperty('--bm-engraving-font-scale', input.getAttribute('data-font-scale') || '1');
    }

    Array.prototype.forEach.call(fontInputs, function (input) {
      input.addEventListener('change', function () {
        applyFont(input);
        picker.classList.remove('is-invalid');
      });
    });

    function addHidden(name, value) {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = name;
      hidden.value = value;
      hidden.setAttribute('data-engraving-font-clone', 'true');
      form.appendChild(hidden);
    }

    function injectFontInput() {
      if (!form) return;
      var old = form.querySelectorAll('input[data-engraving-font-clone]');
      Array.prototype.forEach.call(old, function (el) { el.remove(); });

      var selected = getSelectedFont();
      if (!selected) return;

      addHidden('properties[Engraving font]', selected.value);
      addHidden('properties[_Engraving font file]', selected.getAttribute('data-font-file') || selected.value);
    }

    function validateFont() {
      if (!picker) return true;
      if (getSelectedFont()) return true;

      picker.classList.add('is-invalid');
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      alert('Please choose a font.');
      if (fontInputs[0]) fontInputs[0].focus({ preventScroll: true });
      return false;
    }

    if (form && picker) {
      // Capture on the FORM so this runs before bm-engraving.js's listener on the button:
      // the font is checked first, matching the order on the page (font above text).
      form.addEventListener('click', function (event) {
        if (!event.target.closest('[data-add-to-cart]')) return;

        if (!validateFont()) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          return;
        }
        injectFontInput();
      }, true);

      form.addEventListener('submit', function (event) {
        if (!validateFont()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        injectFontInput();
      }, true);
    }

    /* -- 3. Carry choices across a "Ring style" switch -------------------- */
    function selectedSymbolKey() {
      var btn = root.querySelector('[data-symbol-mode="single"] [data-symbol-item].is-selected');
      return btn ? btn.getAttribute('data-symbol-key') : '';
    }

    // Save just before leaving via a Ring style (product family) swatch
    document.addEventListener('click', function (event) {
      var link = event.target.closest('.product-family a[href]');
      if (!link) return;

      var selectedFont = getSelectedFont();
      storageSet(CARRY_KEY, JSON.stringify({
        ts: Date.now(),
        text: textInputs[0] ? textInputs[0].value : '',
        font: selectedFont ? selectedFont.value : '',
        symbol: selectedSymbolKey()
      }));
    }, true);

    // Restore on arrival (one-time; cleared immediately)
    var raw = storageGet(CARRY_KEY);
    storageRemove(CARRY_KEY);
    if (!raw) return;

    var carried;
    try { carried = JSON.parse(raw); } catch (e) { return; }
    if (!carried || Date.now() - (carried.ts || 0) > CARRY_MAX_AGE_MS) return;

    if (carried.font) {
      Array.prototype.forEach.call(fontInputs, function (input) {
        if (input.value === carried.font) {
          input.checked = true;
          applyFont(input);
        }
      });
    }

    if (carried.text && textInputs[0]) {
      textInputs[0].value = carried.text.slice(0, textInputs[0].maxLength > 0 ? textInputs[0].maxLength : undefined);
      textInputs[0].dispatchEvent(new Event('input', { bubbles: true }));
    }

    if (carried.symbol) {
      var symbolBtn = root.querySelector(
        '[data-symbol-mode="single"] [data-symbol-item][data-symbol-key="' +
        String(carried.symbol).replace(/["\\]/g, '\\$&') + '"]'
      );
      // bm-engraving.js (loaded before this file) owns selection state - let it handle the click
      if (symbolBtn && !symbolBtn.classList.contains('is-selected')) symbolBtn.click();
    }
  });
})();
